import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { useSearchState } from '@droplet-tech-code/core-elements/module/ui/Search/Search';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { PurchaseListItemResponse } from '@naus-code/naus-admin-types';
import { useCallback, useRef, useState } from 'react';
import { RefreshControl } from 'react-native';

import { FlatList } from '~/components/FlatList/FlatList';
import { useItemSeparatorComponent } from '~/components/FlatList/FlatList.Common';
import { useChangeParam } from '~/components/Modals/ChangeParamModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

import { PurchaseListItemComponent } from '../Purchase.ListItem';
import { purchaseApi } from '../Purchases.api';
import { PurchasesCRCListHeader } from './PurchasesByCRC.ListHeader';

export interface PurchaseListProps {
  onPress: (purchase: PurchaseListItemResponse) => void;
  companyReservationCode: string;
}

export const PurchaseListNative = ({
  companyReservationCode,
}: {
  companyReservationCode: string;
}) => {
  const navigate = useAppNavigation();
  return (
    <PurchaseList
      companyReservationCode={companyReservationCode}
      onPress={(item) => {
        navigate.navigate('Purchase-Item', {
          id: item.id,
        });
      }}
    />
  );
};

export const PurchaseList = (props: PurchaseListProps) => {
  const selectedRef = useRef('');
  const [companyReservationCode, setCompanyReservationCode] = useState(
    props.companyReservationCode,
  );

  const { list, Search, isLoading, isFetching, refetch } = useSearchState({
    hook: purchaseApi.useGetPurchaseListByCompanyResCodeQuery,
    style: {
      height: 47,
    },
    keyToList: 'purchases',
    arg: { companyReservationCode },
  });

  const renderItem = useCallback((purchase: PurchaseListItemResponse) => {
    return (
      <PurchaseListItemComponent
        key={purchase.id}
        purchase={purchase}
        onPress={() => {
          selectedRef.current = purchase.id;
          props.onPress(purchase);
        }}
      />
    );
  }, []);
  const { open: openEditParam } = useChangeParam();

  const onEditCompanyCode = (param: string) => {
    setCompanyReservationCode(param);
  };

  const ItemSeparatorComponent = useItemSeparatorComponent();

  return (
    <VStack flex={1}>
      <PurchasesCRCListHeader
        companyResCode={companyReservationCode}
        onReset={() => {
          openEditParam({
            initialValue: companyReservationCode,
            title: translate('purchases.purchasesByCompanyResCode'),
            subtitle: translate('purchases.enterCRC'),
            label: translate('purchases.companyReservationCode'),
            onConfirm: onEditCompanyCode,
          });
        }}
        onPress={() => refetch()}
      />
      {Search}
      <Divider />
      <FlatList
        refreshControl={
          <RefreshControl refreshing={isFetching} onRefresh={() => refetch()} />
        }
        feedback={translate('purchases.emptyPurchases')}
        isLoading={isLoading}
        data={list}
        renderItem={renderItem}
        simple
        onPressItem={(v) => {
          selectedRef.current = v.id;
          props.onPress(v);
        }}
        ItemSeparatorComponent={ItemSeparatorComponent}
      />
    </VStack>
  );
};
